export default __webpack_public_path__ + "static/04_Odin-f21262adca8c35e467082b1f69112d4c.pdf";